<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <form class="form-inline">
            <input v-model="ShowDate" @change="loadData()" type="date" class="form-control" />

            <select v-model="SelectedSet" @change="changeSelected()" class="form-control ml-sm-2">
              <option
                v-for="FavSet in FavSets"
                :value="FavSets.indexOf(FavSet)"
                :key="FavSets.indexOf(FavSet)"
              >{{FavSets.indexOf(FavSet)}}: {{FavSet.Description}}</option>
            </select>

            <router-link
              :to="{name:'favsetedit', params:{favsetid: SelectedSet}}"
              class="btn btn-link"
            >Edit FavSet</router-link>

            <router-link
              :to="{name:'favsetedit', params:{favsetid: -1}}"
              class="btn btn-link"
            >New FavSet</router-link>
          </form>
        </div>
      </div>
    </div>

    <br />

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Channel</th>
          <th
            v-for="ShowTime in ShowTimeHeader"
            :key="ShowTime.ShowTimeISO"
            :title="ShowTime.ShowTime"
          >{{ShowTime.ShowTimeStr}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in Rows" :key="row.Channel.Number">
          <td>
            <router-link
              :to="{name:'masterdetailselected', params:{chcode: row.Channel.Number}}"
            >{{row.Channel.Name}} {{row.Channel.Number}}</router-link>
          </td>
          <td v-for="cell in row.Cells" :key="cell.Show.DateStart" :colspan="cell.Span">
            <span>{{cell.Show.Title}}</span>
            <br />
            <span
              v-if="!!cell.Show.Channel"
            >{{cell.Show.ChannelNumber}}: {{cell.Show.DateStartStr}} - {{cell.Show.DateEndStr}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import API from "../apis/firstmedia.js";
import moment from "moment";
import _ from "lodash";

export default {
  data() {
    return {
      SelectedSet: this.$store.state.settings.settings.SelectedSet,
      ShowDate: moment().format("YYYY-MM-DD"),
      ServerResponse: { Schedules: [] },
      ShowTimeHeader: [],
      Rows: []
    };
  },
  computed: {
    FavSets() {
      return this.$store.state.settings.settings.FavSets;
    }
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      let channelNumbers = this.FavSets[this.SelectedSet].Channels.map(
        c => c.Number
      );
      let dateStart = moment(this.ShowDate)
        .startOf("day")
        .toISOString();
      let dateEnd = moment(dateStart)
        .add(1, "days")
        .toISOString();

      let spinnerToken = await this.$store.dispatch("spinner/needSpinner");
      this.ServerResponse = await API.getSchedule(
        channelNumbers,
        dateStart,
        dateEnd
      );
      this.$store.dispatch("spinner/dontNeedSpinner", spinnerToken);

      this.ServerResponse.Channels.forEach(c => {
        let overlaps = this.getOverlappingSchedules(
          c.Number,
          this.ServerResponse.Schedules
        );
        if (overlaps.length > 0) {
          this.$store.dispatch("notification/notify", {
            message: overlaps,
            vm: this
          });
        }
      });

      this.ServerResponse.Schedules.forEach(s => {
        s.DateStart = moment(s.DateStart).toISOString();
        s.DateStartStr = moment(s.DateStart).format("HH:mm");
        s.DateEnd = moment(s.DateEnd).toISOString();
        s.DateEndStr = moment(s.DateEnd).format("HH:mm");
        s.Channel = this.ServerResponse.Channels.find(
          c => c.Number == s.ChannelNumber
        );
      });

      this.ServerResponse.Schedules.forEach(s => {
        s.DateStartView = s.DateStart < dateStart ? dateStart : s.DateStart;
        s.DateEndView = s.DateEnd > dateEnd ? dateEnd : s.DateEnd;
      });

      this.ShowTimeHeader = this.generateShowTimeHeaders(
        this.getAllShowTimes(this.ServerResponse.Schedules),
        dateStart,
        dateEnd
      );

      this.Rows = this.ServerResponse.Channels.map(channel => {
        return {
          Channel: channel,
          Cells: this.generateCells(
            channel,
            this.ServerResponse.Schedules,
            this.ShowTimeHeader
          )
        };
      });
    },
    changeSelected() {
      let allSettings = this.$store.state.settings.settings;
      allSettings.SelectedSet = this.SelectedSet;
      this.$store.dispatch("settings/updateAll", allSettings);
      this.loadData();
    },
    getAllShowTimes(schedules) {
      let showtimes = schedules
        .map(s => s.DateStart)
        .concat(schedules.map(s => s.DateEnd));
      let uniqueTimes = Array.from(new Set(showtimes));
      let sortedTimes = _.sortBy(uniqueTimes, t => t);
      return sortedTimes;
    },
    generateShowTimeHeaders(allShowTimes, timeStart, timeEnd) {
      if (allShowTimes.find(t => t < timeStart)) {
        allShowTimes = allShowTimes.filter(t => t >= timeStart);
        if (!allShowTimes.includes(timeStart)) {
          allShowTimes.unshift(timeStart);
        }
      }

      if (allShowTimes.find(t => t > timeEnd)) {
        allShowTimes = allShowTimes.filter(t => t <= timeEnd);
        if (!allShowTimes.includes(timeEnd)) {
          allShowTimes.push(timeEnd);
        }
      }

      let asObj = allShowTimes.map(t => ({
        ShowTimeISO: t,
        ShowTime: moment(t).toDate(),
        ShowTimeStr: moment(t).format("HH:mm")
      }));

      return asObj;
    },
    generateCells(channel, schedules, allShowTimes) {
      let cells = [];
      let allShowTimesISO = allShowTimes.map(t => t.ShowTimeISO);

      for (const showTime of allShowTimes) {
        let currentShow = schedules.find(
          s =>
            s.ChannelNumber == channel.Number &&
            s.DateStartView <= showTime.ShowTimeISO &&
            s.DateEndView > showTime.ShowTimeISO
        );

        if (!currentShow) {
          // if no shows found, insert blank cell
          let cell = {
            Show: {},
            Span: 1
          };
          cells.push(cell);
          continue;
        }

        if (currentShow.DateStartView == showTime.ShowTimeISO) {
          // if start time match
          let startIdx = allShowTimesISO.indexOf(currentShow.DateStartView);
          let endIdx = allShowTimesISO.indexOf(currentShow.DateEndView);
          let span = endIdx - startIdx;
          let cell = {
            Show: currentShow,
            Span: span
          };
          cells.push(cell);
          continue;
        }

        // has show but start time doesn't match: do nothing
      }
      return cells;
    },
    getOverlappingSchedules(channelNumber, schedules) {
      let overlap = schedules.filter(
        schedule =>
          schedule.ChannelNumber == channelNumber &&
          !!schedules.find(
            other =>
              schedule != other &&
              schedule.ChannelNumber == other.ChannelNumber &&
              schedule.DateStart < other.DateEnd &&
              schedule.DateEnd > other.DateStart
          )
      );
      return overlap;
    }
  }
};
</script>